import { gql } from '../../../__generated__';

export const DELETE_LOCATION_GROUP = gql(`
  mutation DeleteLocatonGroup($locationGroupId: String!) {
    deleteLocationGroup(locationGroupId: $locationGroupId) {
      success
    }
  }
`);
